import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import api from '../../../api'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import { Container } from '../../../assets/styles/GlobalStyle'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import LeftThreeDot from '../../../assets/v2/JSX/LeftThreeDot'
import RedCross from '../../../assets/v2/JSX/RedCross'
import RightThreeDot from '../../../assets/v2/JSX/RightThreeDot'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import CompanySelect from '../../../components/v2/CompanySelect'
import Dropdown from '../../../components/v2/Dropdown'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { currencySymbol, georgianFormatter } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  TplState,
  setCompanyOffers,
  setCurrency,
  setLimit,
  setOffer,
  setOfferTotalPrice,
  setPayment,
  setPaymentSchedule,
  setPaymentScheduleMethods,
  setSelectedCompanies,
} from '../../../store/tplSlice'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../../store/appSlice'

const TplOffer = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  // page info texts
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetTplOfferPageInfoQuery(undefined)
  //
  // page title
  const pageTitle = pageInfo?.translations[lang]?.title
  //
  // step name
  const stepName = pageInfo?.translations[lang]?.stepName
  //
  // payment methods
  const { data: tplPaymentMethods, isLoading: isTplPaymentMethodsLoading } = api.useGetTplPaymentMethodsQuery(undefined)
  //
  //
  // set payment method in store callback
  const setPaymentMethodInStore = useCallback(() => {
    if (tplPaymentMethods && tplPaymentMethods.length >= 1) {
      dispatch(setPaymentScheduleMethods(tplPaymentMethods))
    }
  }, [dispatch, tplPaymentMethods])
  //
  //
  // set payment method in store action
  useEffect(() => {
    setPaymentMethodInStore()

    return () => {}
  }, [setPaymentMethodInStore])

  //
  //
  const { data: limitsFromApi, isLoading: isLimitsFromApi } = api.useGetTplLimitsByCurrencyQuery(
    filter.currency as string,
    {
      skip: !filter.currency && true,
    },
  )
  //
  //
  const customCompanyIds =
    filter.chooseMethod === 'my-choice' ? `&CompanyIds=${filter.selectedCompanies?.map((x) => x.id)}` : ''
  //
  //
  const paymentIds = tplPaymentMethods
    ?.filter(
      (x) => x.slug.split('-')[0].toUpperCase() === filter.seletedPaymentMethod?.type.split('-')[0].toUpperCase(),
    )
    .map((x) => x.id)
  //
  // ? OFFER
  const query = `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${
    filter.dates?.end
  }&Currency=${filter.currency?.toUpperCase()}&Limit=${filter.limit}&PackageServiceIds=${
    filter.selectedServices
  }${customCompanyIds}&PaymentScheduleTypeIds=${paymentIds}`
  //
  //
  const { data: tplOffers, isLoading: isTplOfferLoading } = api.useGetTplOfferQuery(
    {
      query: query,
    },
    {
      skip:
        filter.selectedServices &&
        filter.selectedServices.length >= 1 &&
        tplPaymentMethods &&
        tplPaymentMethods.length >= 1
          ? false
          : true,
      refetchOnMountOrArgChange: true,
    },
  )
  //
  const setOfferInStore = useCallback(() => {
    // frani choice
    if (tplOffers && tplOffers.length >= 1 && filter.chooseMethod === 'frani-choice') {
      const bestOffer = tplOffers.find((x) => x.isBestOption === true)
      //
      if (bestOffer) {
        dispatch(setOffer(bestOffer))
      }
    }
    //
    // user choice
    if (tplOffers && tplOffers.length >= 1 && filter.chooseMethod === 'my-choice') {
      //
      const existingCompanyOffer = tplOffers.find((x) => x.companyId === filter.offerFromUser?.id)
      //
      if (filter.offerFromUser) {
        dispatch(setOffer(existingCompanyOffer))
      }
      //
    }
    //
  }, [tplOffers, dispatch, filter.chooseMethod, filter.offerFromUser])
  //
  const setPaymentInStore = useCallback(() => {
    //
    if (tplOffers && tplOffers.length >= 1 && filter?.offer && filter?.offer?.payment) {
      dispatch(
        setPayment({
          firstPaymentAmount: filter.offer.payment.firstPaymentAmount,
          monthlyPaymentAmount: filter.offer.payment.monthlyPaymentAmount,
          totalPaymentAmount: filter.offer.payment.totalPaymentAmount,
        }),
      )
      //
    }
  }, [tplOffers, dispatch, filter.offer])
  //

  // auto set main offer in redux store
  useEffect(() => {
    //
    setOfferInStore()
    //
    return () => {}
  }, [setOfferInStore])
  //
  useEffect(() => {
    //
    setPaymentInStore()
    //
    return () => {}
  }, [setPaymentInStore])
  //
  //
  // set offers in redux store for next steps
  const setOfferCompanyCallBack = useCallback(async () => {
    if (tplOffers && tplOffers.length >= 1) {
      dispatch(setCompanyOffers(tplOffers))
    }
    //
  }, [tplOffers, dispatch])
  //
  //
  useEffect(() => {
    setOfferCompanyCallBack()
    //
    return () => {}
  }, [setOfferCompanyCallBack])
  //
  //
  //
  const sortedOffersByMontlyAmount = tplOffers
    ?.slice()
    ?.sort((a, b) => a?.payment?.monthlyPaymentAmount - b?.payment?.monthlyPaymentAmount)
  const sortedOffersByTotalAmount = tplOffers
    ?.slice()
    ?.sort((a, b) => a?.payment?.totalPaymentAmount - b?.payment?.totalPaymentAmount)
  //
  const sortedOffers =
    filter.offer?.paymentScheduleType.slug === 'ONE-TIME' ? sortedOffersByTotalAmount : sortedOffersByMontlyAmount
  //
  //
  //
  // custom price scroll position in number
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })
  //
  const _Price =
    tplOffers && tplOffers.length >= 1
      ? filter.offer?.paymentScheduleType.slug === 'ONE-TIME'
        ? georgianFormatter.format(filter.payment?.totalPaymentAmount as number)
        : georgianFormatter.format(filter.payment?.firstPaymentAmount as number)
      : '0'
  //
  // set payment price
  useEffect(() => {
    if (_Price) {
      dispatch(setOfferTotalPrice(_Price?.toString()))
    }
    //
    return () => {}
  }, [_Price, dispatch])
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoading = isPageInfoLoading || isTplOfferLoading || isLimitsFromApi || isTplPaymentMethodsLoading
  //
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <Schedule>
          <span
            className="payment-montly"
            style={{
              color: filter.seletedPaymentMethod?.type === 'MONTHLY' ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('monthly')}
          </span>
          <ToggleSwitcher
            activeRedBackground={true}
            defaultValue={filter.seletedPaymentMethod?.type === 'MONTHLY' ? false : true}
            onChange={(value) => {
              if (value === true && tplPaymentMethods) {
                //
                return [
                  dispatch(
                    setPaymentSchedule({
                      id: tplPaymentMethods?.find((x) => x.slug === 'ONE-TIME')?.id || 0,
                      type: 'ONE-TIME',
                    }),
                  ),
                ]
              } else {
                //
                return [
                  dispatch(
                    setPaymentSchedule({
                      id: tplPaymentMethods?.find((x) => x.slug === 'MONTHLY')?.id || 0,
                      type: 'MONTHLY',
                    }),
                  ),
                ]
              }
            }}
          />
          <span
            className="payment-annual"
            style={{
              color: filter.seletedPaymentMethod?.type === 'MONTHLY' ? Colors.primaryBlack : Colors.nevadaGrey,
            }}
          >
            {t('annual')}
          </span>
        </Schedule>

        <Price
          $pricePosition={scrollPosition}
          style={{
            userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
            pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
            opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
          }}
        >
          <LeftThreeDot />
          <div>
            {_Price} {currencySymbol(filter.currency)}
          </div>
          <RightThreeDot />
        </Price>

        {tplOffers && tplOffers.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '30px',
            }}
            text={t('offerNotFoundChangeSetting')}
          />
        )}

        <Block>
          {tplOffers && tplOffers.length >= 1 ? (
            <>
              <OfferTitle
                style={{
                  userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
                }}
              >
                {t('see')}{' '}
                <b>{filter.incomeCompanies?.find((x) => x.id === filter.offer?.companyId)?.brandName?.[lang]?.title}</b>{' '}
                {t('seeCompanyOffer')}
              </OfferTitle>

              <OfferDescription
                style={{
                  userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
                }}
              >
                {t('youCanChooseOtherCompany')}
              </OfferDescription>
            </>
          ) : null}

          <CompanySelect
            style={{
              userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
              opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
            }}
            closeMenuOnSelect={true}
            title={t('selectCompanies')}
            value={tplOffers && tplOffers.length >= 1 ? filter.offer?.companyId : null}
            onChange={(data) => {
              if (data.value) {
                return [dispatch(setOffer(tplOffers?.find((x) => x.companyId === data.value)))]
              }
            }}
            isMulti={false}
            maxSelectLenght={3}
            maxSelectText={`${t('companyCmpare')}`}
            showInnerPrice={true}
            showOptionCheckmark={true}
            options={sortedOffers?.map((o) => ({
              value: o.companyId,
              label: o.brandName?.[lang]?.title,
              imgUrl: o.translations?.[lang]?.logo,
              price:
                o.paymentScheduleType.slug === 'ONE-TIME'
                  ? o?.payment?.totalPaymentAmount
                  : o?.payment?.monthlyPaymentAmount,
            }))}
          />
          <br />

          <AddonsTitle>{t('youCanChange')}</AddonsTitle>

          <DropdownWrapper>
            <Dropdown
              title={`${t('currency')}`}
              value={filter.currency}
              options={filter.currencies?.map((x) => ({
                value: x,
                label: x,
              }))}
              placeholder={``}
              onChange={(obj) => dispatch(setCurrency(obj.value))}
            />

            <Dropdown
              title={`${t('limit')}`}
              value={filter?.limit}
              options={limitsFromApi?.map((x) => ({
                value: x,
                label: `${x}`,
              }))}
              placeholder={``}
              onChange={(obj) => dispatch(setLimit(obj.value))}
            />
          </DropdownWrapper>

          <div
            style={{
              userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
              pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
              opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
            }}
          >
            <HR />

            <ServiceTitle>{t('service')}</ServiceTitle>
            <br />

            {filter.incomeServices?.map((item, index) => (
              <OfferTextBox key={index}>
                <OffetTextLeftSide>{item.translations?.[lang]?.name}</OffetTextLeftSide>
                <OffetTextRightSide>
                  {filter.offer?.packageServices?.find((x) => x.id === item.id) ? <GreenTick /> : <RedCross />}
                </OffetTextRightSide>
              </OfferTextBox>
            ))}

            <HR />

            <OfferTextBox>
              <OffetTextLeftSide>{t('policyType')}</OffetTextLeftSide>
              <OffetTextRightSide>
                {filter.seletedPaymentMethod?.type === 'MONTHLY'
                  ? `${filter.offer?.paymentScheduleType.number} ${t('month')}`
                  : t('annual')}
              </OffetTextRightSide>
            </OfferTextBox>

            <OfferTextBox>
              <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
              <OffetTextRightSide>
                {filter.offer?.days} {t('day')}
              </OffetTextRightSide>
            </OfferTextBox>

            {tplOffers && tplOffers.length >= 1 && filter.seletedPaymentMethod?.type === 'MONTHLY' ? (
              <>
                <HR />

                <OfferTextBox>
                  <OffetTextLeftSide>{t('paymentSchedule')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {filter.offer?.paymentScheduleType?.translations?.[lang]?.title}
                  </OffetTextRightSide>
                </OfferTextBox>

                {filter.offer?.payment?.firstPaymentAmount && (
                  <OfferTextBox>
                    <OffetTextLeftSide>{t('currentPayment')}</OffetTextLeftSide>
                    <OffetTextRightSide>
                      {filter?.offer?.payment?.firstPaymentAmount} {currencySymbol(filter.currency)}
                    </OffetTextRightSide>
                  </OfferTextBox>
                )}

                <OfferTextBox>
                  <OffetTextLeftSide>{t('eachPayment')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {filter?.offer?.payment?.monthlyPaymentAmount} {currencySymbol(filter.currency)}
                  </OffetTextRightSide>
                </OfferTextBox>

                <OfferTextBox>
                  <OffetTextLeftSide>{t('annualPaymentTitle')}</OffetTextLeftSide>
                  <OffetTextRightSide>
                    {filter?.offer?.payment?.totalPaymentAmount} {currencySymbol(filter.currency)}
                  </OffetTextRightSide>
                </OfferTextBox>
              </>
            ) : null}

            <HR />

            <Summary>
              <PriceInfo>
                <PriceText>
                  {_Price}
                  {currencySymbol(filter.currency)}
                </PriceText>
              </PriceInfo>
              <ATagStyle
                style={{
                  userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
                  opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
                }}
                href={filter.offer?.termsPath?.translations?.[lang]?.url || ''}
                target="_blank"
              >
                <div>{t('policyTerms')}</div>
              </ATagStyle>
            </Summary>
          </div>
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return [navigate('/tpl-which-method'), dispatch(setOffer(undefined))]
              }
              //user-choice
              if (filter.chooseMethod === 'my-choice') {
                //
                const companies = filter.selectedCompanies?.map((s) => ({
                  id: s.id,
                  currency: filter.currency,
                  limit: filter.limit,
                }))
                //
                return [dispatch(setSelectedCompanies(companies as never)), navigate('/tpl-offers')]
              }
              //
              return navigate('/tpl-which-method')
              //
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={tplOffers && tplOffers.length >= 1 ? false : true}
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return navigate('/tpl-insurance-for')
              }
              //
              if (filter.chooseMethod === 'my-choice') {
                return navigate('/tpl-insurance-for')
              }
            }}
          />
        </Buttons>
      </Content>

      <Container
        style={{
          userSelect: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
          pointerEvents: tplOffers && tplOffers.length >= 1 ? 'unset' : 'none',
          opacity: tplOffers && tplOffers.length >= 1 ? 'unset' : '0.6',
        }}
      >
        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('whatIsCovered')}</span>
            </MessageHead>
            {filter.offer?.package?.tplPackage?.coverages?.map((coverage, coverageIndex) => (
              <MessageText key={coverageIndex}>
                <DoubleRightIcon /> <span>{coverage?.translations?.[lang]?.body}</span>
              </MessageText>
            ))}
          </MessageContent>
        </MessageBox>

        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('notCovered')}</span>
            </MessageHead>
            {filter.offer?.package?.tplPackage?.importantTerms?.map((item, index) => (
              <MessageText key={index}>
                <DoubleRightIcon /> <span>{item?.translations?.[lang]?.body}</span>
              </MessageText>
            ))}
          </MessageContent>
        </MessageBox>
      </Container>

      {scrollPosition <= 0 && <BackgroundIcon />}
    </Wrapper>
  )
}
//
const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;
  user-select: none;
  position: relative;
  width: fit-content;
  margin-inline: auto;

  .payment-montly {
    right: 35px;
  }

  .payment-annual {
    left: 35px;
  }

  span {
    position: absolute;
    font-size: 14px;
    /* color: ${Colors.primaryBlack}; */
    :first-child {
      padding-right: 10px;
    }
    :last-child {
      padding-left: 10px;
    }
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /*  */
  &:last-child {
    margin-bottom: 0px;
  }

  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;

    /* message text span */
    span {
      margin-left: 15px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div`
  :first-child {
    border-top: 1px solid ${Colors.secondaryGrey};
    margin-top: 80px;
  }
  padding-top: 30px;
  ${Responsive.tablet} {
    max-width: 700px;
    margin: 0 auto;
  }
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 10px;
  color: ${Colors.primaryBlack};
  text-align: right;
  div {
    line-height: 18px;
    &:last-child {
      margin-left: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 16px;
        height: 10px;
      }
    }
  }
  /*  */
  &:hover {
    color: ${Colors.primaryBlack};
    div {
      svg {
        color: ${Colors.primaryRed};
      }
    }
  }
`
const OfferTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`
const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
  text-transform: capitalize;
  text-align: right;
`
const HR = styled.hr`
  margin-block: 24px;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  ${Responsive.laptop} {
    gap: 2rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 2rem 2rem;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem 2rem;
  }
`
const OfferDescription = styled.h6`
  font-size: 14px;
  margin-bottom: 30px;
  color: ${Colors.nevadaGrey};
`
const OfferTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const AddonsTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const Price = styled.div<{ $pricePosition: number }>`
  position: sticky;
  top: 100px;
  right: 0;
  width: fit-content;
  margin: ${({ $pricePosition }) => ($pricePosition >= 170 ? '0 -300px 0 auto' : '0 auto')};
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  user-select: none;
  pointer-events: none;

  /* text */
  div {
    width: fit-content;
    height: 64px;
    background-color: ${Colors.primaryRed};
    border-radius: 40px;
    color: ${Colors.white};
    font-size: 20px;
    padding-inline: 40px;
    margin-inline: 10px;
    display: grid;
    place-items: center;
    box-shadow: 0 4px 35px 0 rgba(254, 95, 85, 0.32);
  }

  svg {
    height: 64px;
  }

  /* Responsive */
  ${Responsive.laptop} {
    top: 120px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 120 ? '0 -200px 0 auto' : '0 auto')};
    margin-top: 32px;

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      height: 40px;
    }
  }

  ${Responsive.tablet} {
    top: 100px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 160 ? 'none' : 'unset')};
      height: 40px;
    }
  }

  ${Responsive.mobile} {
    top: 80px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 100 ? 'none' : 'unset')};
      height: 40px;
    }
  }
`
const Block = styled.div`
  max-width: 800px;
  width: calc(100vw - 96px);
  padding: 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  margin-block: 48px;
  border-radius: 8px;

  ${Responsive.mobile} {
    margin-block: 33px;
    padding: 20px;
    width: calc(100vw - 40px);
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`
const ServiceTitle = styled.h6`
  font-size: 14px;
  color: ${Colors.primaryBlack};
`
const Summary = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
`
// const Percentage = styled.span`
//   margin-left: 10px;
//   margin-top: 3px;
//   font-size: 14px;
//   color: ${Colors.nevadaGrey};
//   text-align: left;

//   b {
//     color: ${Colors.primaryRed};
//   }

//   ${Responsive.mobile} {
//     margin-left: 0px;
//   }
// `
const PriceText = styled.span`
  font-size: 28px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 2px;
`
const PriceInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Responsive.mobile} {
    display: block;
  }
`
//
export default TplOffer
